namespace GeniuzPOS.SalePromoCamp {
    export namespace PsPromoApDtService {
        export const baseUrl = 'SalePromoCamp/PsPromoApDt';

        export declare function Create(request: Serenity.SaveRequest<PsPromoApDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsPromoApDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsPromoApDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsPromoApDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "SalePromoCamp/PsPromoApDt/Create",
            Update = "SalePromoCamp/PsPromoApDt/Update",
            Delete = "SalePromoCamp/PsPromoApDt/Delete",
            Retrieve = "SalePromoCamp/PsPromoApDt/Retrieve",
            List = "SalePromoCamp/PsPromoApDt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsPromoApDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
